import { IoDocumentAttachOutline } from "react-icons/io5";

const TransporterInvoiceIcon = () => {
  return <IoDocumentAttachOutline size={22} className="sidebar-icon" />;
};
export default TransporterInvoiceIcon;
